import { useState } from "react";
import { mutate } from "swr";

import { fetcher } from "../services/config";
import { MethodType } from "../services/type";
import { getQueryString } from "@utils/utilsApi";

export function useDeleteProfileImg(userId?: string, corporateId?: string) {
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteProfileImg = async () => {
    if (!userId) return;
    setIsDeleting(true);
    try {
      await fetcher(
        getQueryString(`/mediamanager/userprofile/${userId}/image`, {
          corporateId: corporateId ?? "",
        }),
        MethodType.DELETE,
      );
      await mutate([
        `/mediamanager/userprofile/${userId}/image`,
        MethodType.GET,
      ]);
    } finally {
      setIsDeleting(false);
    }
  };

  return { deleteProfileImg, isDeleting };
}
